import React, { useState } from "react";
import { incidentCodigoOptions, incidentIncidenciaOptions, allResponsables } from "./options_incidents";

function CreateIncident () {
    const [damageValue, setDamageValue] = useState('');  // Para guardar el valor de la opcion seleccionada en incident_damage
    const [codigoOptions, setCodigoOptions] = useState([]);  // Para guardar el arreglo de opciones dependiendo de la opcion seleccionada en incident_damage
    const [codigoValue, setCodigoValue] = useState('');  // Para guardar el valor de la opcion seleccionada en incident_codigo
    const [incidenciaOptions, setIncidenciaOptions] = useState([]);  // Para guardar el arreglo de opciones dependiendo de la opcion seleccionada en incident_codigo
    const [selectedIncidenciaId, setSelectedIncidenciaId] = useState('');  // Para guardar el id de la opcion seleccionada en incident_incidencia
    const [responsableOption, setResponsableOption] = useState(null);  // Para guardar la opcion del responsable dependiendo de la opcion seleccionada en incident_incidencia

    const handleDamageChange = (e) => {
        const value = e.target.value;
        setDamageValue(value);
        
        // Simulando petición al backend (como si fuera Axios)
        if (incidentCodigoOptions[value]) {
            setCodigoOptions(incidentCodigoOptions[value]);
        } else {
            setCodigoOptions([]);
        }
    };

    const handleCodigoChange = (e) => {
        const value = e.target.value;
        setCodigoValue(value);

        if (incidentIncidenciaOptions[value]) {
            setIncidenciaOptions(incidentIncidenciaOptions[value]);
        } else {
            setIncidenciaOptions([]);
        }
    };

    const handleIncidenciaChange = (e) => {
        const selectedId = e.target.value;
        setSelectedIncidenciaId(selectedId);

        const incidencia = incidenciaOptions.find(opt => opt.id === parseInt(selectedId));
        if (incidencia && incidencia.incident_responsable_id) {
            // Simulación de "fetch" al backend de responsables
            const responsable = allResponsables.find(r => r.id === incidencia.incident_responsable_id);
            setResponsableOption(responsable || null);
        } else {
            setResponsableOption(null);
        }
    };

    const handleAccept = () => {
        console.log("Aceptar");
    }

    const onlyAllowNumbers = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, '');

        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts[1];
        }

        e.target.value = value;
    };

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <label for="pieces" class="amc-label">Piezas</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="pieces"
                            onInput={onlyAllowNumbers}
                            /* value={userName} */
                        />
                    </div>
                    <div className="col-6">
                        <label for="weight" class="amc-label">Peso</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="weight"
                            onInput={onlyAllowNumbers}
                            /* value={userName} */
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <label for="incident_operation" class="amc-label">Operación</label>
                        <select
                            class="form-select"
                            name="incident_operation"
                            /* value={userName} */
                        >
                            <option disabled selected value="">Selecciona ...</option>
                            <option value="1">MEX</option>
                            <option value="2">TTO</option>
                            <option value="3">OAL</option>
                        </select>
                    </div>
                    <div className="col-6">
                        <label for="incident_damage" class="amc-label">Error en:</label>
                        <select
                            class="form-select"
                            name="incident_damage"
                            value={damageValue}
                            onChange={handleDamageChange}
                        >
                            <option disabled selected value="">Selecciona ...</option>
                            <option value="1">Documentos</option>
                            <option value="2">Carga</option>
                            <option value="3">Sistema</option>
                            <option value="4">Logistica</option>
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <label for="incident_codigo" class="amc-label">Codigo</label>
                        <select
                            class="form-select"
                            name="incident_codigo"
                            value={codigoValue}
                            onChange={handleCodigoChange}
                        >
                            <option disabled selected value="">Selecciona ...</option>
                            {codigoOptions.map((option) => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-6">
                        <label for="incident_inciencia" class="amc-label">Incidencia</label>
                        <select
                            class="form-select"
                            name="incident_inciencia"
                            value={selectedIncidenciaId}
                            onChange={handleIncidenciaChange}
                        >
                            <option disabled selected value="">Selecciona ...</option>
                            {incidenciaOptions.map((option) => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <label for="incident_responsable" class="amc-label">Responsable</label>
                        <select
                            class="form-select"
                            name="incident_responsable"
                            /* value={codigoValue}
                            onChange={handleCodigoChange} */
                        >
                            <option disabled selected value="">Selecciona ...</option>
                            <option value={responsableOption?.id}>{responsableOption?.name}</option>
                            {/* {codigoOptions.map((option) => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))} */}
                        </select>
                    </div>
                    <div className="col-6">
                        <label for="observations" class="amc-label">Observaciones</label>
                        <textarea name="observations" className="form-control" rows="4" />
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end">
                        <button className='btnn' onClick={handleAccept} >Aceptar</button>
                    </div>
                </div>
            </div>
        </>
    );
}

/* const incidentCodigoOptions = {
  1: [
    { id: 1, name: "(MSAW) FALTANTE DOCS" },
    { id: 2, name: "(FSAW) SOBRANTE DOCUMENTOS" },
    { id: 3, name: "DOCUMENTOS NO LOCALIZADOS" },
    { id: 4, name: "INFORMACIÓN OBLIGATORIA" },
    { id: 5, name: "RECHAZO-MERCANCIA NO DECLARADA" },
    { id: 6, name: "SIN PREALERTA SAT" },
    { id: 7, name: "DISCREPANCIA DOCS/CARGA/SISTEMA" }
  ],
  2: [
    { id: 9, name: "(MSCA) FALTANTE CARGA" },
    { id: 10, name: "(FDCA) SOBRANTE CARGA" },
    { id: 11, name: "(OVCD) SOBREVOLADO" },
    { id: 12, name: "SIN IDENTIFICACIÓN" },
    { id: 13, name: "PUNTOS TÁCTICOS" },
    { id: 14, name: "EMPAQUE/CONTENIDO" },
    { id: 24, name: "DESTRUCCIÓN" },
    { id: 25, name: "OMISIÓN OPERATIVA" }
  ],
  3: [
    { id: 16, name: "CCA EXTEMPOR\u00c1NEO" },
    { id: 17, name: "SIN DEP" },
    { id: 18, name: "VUCEM" },
    { id: 26, name: "CCA" }
  ],
  4: [
    { id: 20, name: "LOGISTICA" },
    { id: 21, name: "RESERVA" },
  ]
}; */

export default CreateIncident;